#! /usr/bin/env node
import * as commander from "commander";
import * as fs from "node:fs";
import * as path from "node:path";
import registerGenerateCommand from "./commands/generate";

const program = new commander.Command();

// Get package version from package.json
const packageJson = JSON.parse(fs.readFileSync(path.join(process.cwd(), "package.json"), "utf8"));

program.name("attio-sdk").description("CLI to generate a TypeScript client for the Attio REST API").version(packageJson.version, "-v, --version");

registerGenerateCommand(program);

program.parse();
